import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export function Forbidden() {
  return (
    <>
      <SEO
        title="403 - Adgang nægtet | MA Hvidevareservice"
        description="Beklager, du har ikke adgang til denne side hos MA Hvidevareservice."
      />

      <section className="py-20 sm:py-28 bg-slate-50 flex-1 flex items-center justify-center">
        <div className="max-w-xl mx-auto px-4 text-center space-y-6">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
            403 – Adgang nægtet
          </h1>

          <p className="text-base text-slate-600 leading-relaxed max-w-md mx-auto">
            Beklager, du har ikke de nødvendige tilladelser til at se denne side eller ressource.
          </p>

          <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              className="w-full sm:w-auto px-6 py-3 bg-sky-600 hover:bg-sky-700 text-white font-semibold text-sm rounded-lg transition-colors shadow-sm inline-flex items-center justify-center"
            >
              <span>Gå til forsiden</span>
            </Link>

            <Link
              to="/kontakt"
              className="w-full sm:w-auto px-6 py-3 bg-white hover:bg-slate-100 text-slate-900 border border-slate-300 font-semibold text-sm rounded-lg transition-colors inline-flex items-center justify-center gap-2"
            >
              <span>Kontakt os</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Forbidden;
